<div class="container">
    <section class="image-gallery">
        <div class="gallery-row">
            <div class="gallery-item gallery-item-narrow">
                <img loading="lazy" src="../../../assets/consultausuarios.png"
                    class="gallery-image gallery-image-square" alt="Gallery image 1" />
            </div>
            <div class="gallery-item gallery-item-wide">
                <img loading="lazy" src="../../../assets/roles.png" class="gallery-image gallery-image-wide"
                    alt="Gallery image 2" />
            </div>
        </div>
        <div class="gallery-row">
            <div class="gallery-item gallery-item-wide">
                <img loading="lazy" src="../../../assets/desbloquear.png" class="gallery-image gallery-image-tall"
                    alt="Gallery image 3" />
            </div>
            <div class="gallery-item gallery-item-narrow">
                <img loading="lazy" src="../../../assets/actualizar.png" class="gallery-image gallery-image-square"
                    alt="Gallery image 4" />
            </div>
        </div>
    </section>
</div>